// Qual aba de pagamento abrir primeiro no paywall.
//
// A tela nascia sempre em 'pix'. Numa conta internacional o Asaas não existe
// (documento estrangeiro não é aceito), então o botão da aba PIX nem é
// renderizado — mas o PAINEL dele continuava aberto, porque `activeTab` seguia
// 'pix'. O cliente via um formulário de PIX que não estava na barra de abas e
// cujo botão só dava erro, sem nenhuma pista de que o caminho dele era o
// cartão. Caso real: conta 67, Certeza Vencedora Lda, 15/08/2026.
//
// A ordem é a preferência comercial (PIX é o mais barato para nós, cartão o
// último), mas só entre as abas que existem de verdade para aquela conta.
export const firstAvailableTab = (gateways = {}) => {
  if (gateways.asaas_available) return 'pix';
  if (gateways.stripe_available) return 'stripe';
  // Nenhum gateway: mantém o padrão histórico para não deixar o painel vazio —
  // a tela ainda mostra o valor devido e o contato do suporte.
  return 'pix';
};

export default { firstAvailableTab };
